export default {
  umAdd: '1564543582003', // 人员管理(user-management)新增
  umUpdate: '1564543582002', // 人员管理修改
  umReset: '1564543582011', // 重置密码
  umExport: '1564543581136', // 人员管理导出
};
